if (!customElements.get('bp-gallery')) {
  customElements.define('bp-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.addEventListener('click', event => {
        const button = event.target.closest('button[aria-controls]');
        if (button && this.contains(button)) this.select(button);
      });
      const initial = this.querySelector('[aria-pressed="true"]');
      if (initial) this.select(initial);
    }
    select(button) {
      const target = button.getAttribute('aria-controls');
      this.querySelectorAll('.bp-gallery__panel').forEach(panel => {
        const active = panel.id === target;
        panel.hidden = !active;
        const player = panel.querySelector('[data-player]');
        if (!player) return;
        if (!active) {
          player.querySelectorAll('video').forEach(video => video.pause());
          player.replaceChildren();
        } else if (!player.childElementCount) {
          player.append(panel.querySelector('template').content.cloneNode(true));
        }
      });
      this.querySelectorAll('button[aria-controls]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
    }
  });
}
